module.exports = __webpack_public_path__ + "files/3a1e677b12d6c4e089c4a0b9cf512826.png";